import { createReducer, on } from '@ngrx/store';
import * as Actions from './actions';
import * as RootActions from '../../actions';
import { AgGridColumnFilter, AgGridColumnSort, MaintenanceCounterDto, MaintenanceDto } from '@services/api/api.service';
import { OnboardedVehicleDto } from '@services/api/sdf-agrirouter-api.service';

export interface State {
  counters: MaintenanceCounterDto;
  maintenances: {
    data: MaintenanceDto[];
    totalCount: number;
    isLoading: boolean;
    paginator: {
      page: number;
      pageSize: number;
    }
    filters: {
      qSearch?: string;
      sortModel?: AgGridColumnSort[];
      filterModel?: { [key: string]: AgGridColumnFilter; }
    };
  };
}


export const initialState: State = {
  counters: {},
  maintenances: {
    data: [],
    totalCount: 0,
    isLoading: false,
    paginator: {
      page: 1,
      pageSize: 10,
    },
    filters: {
      qSearch: '',
    }
  },
};

export const selectMaintenances = state => state.maintenance.maintenances;
export const selectMaintenancesCounters = state => state.maintenance.counters;
export const selectIsMaintenanceLoading = state => state.maintenance.isLoading;
export const selectMaintenanceSummaryData = state => state.maintenance.counters;
export const selectMaintenanceVehicles = state => state.maintenance.vehicles;
export const selectMaintenancePage = state => state.maintenance.page;
export const selectMaintenancePageSize = state => state.maintenance.pageSize;
export const selectMaintenanceTotalNumber = state => state.maintenance.totalNumber;
export const selectMaintenanceFilters = state => state.maintenance.filters;


export const maintenanceReducer = createReducer(
  initialState,
  on(RootActions.resetState, () => ({ ...initialState })),
  on(Actions.setMaintenanceSummary, (state, { value }) => ({ ...state, counters: value })),
  on(Actions.setMaintenanceLoading, (state, { value }) => ({ ...state, isLoading: value })),
  on(Actions.setMaintenanceFilters, (state, { filters }) => ({ ...state, filters })),
  on(Actions.setMaintenanceList, (state, {
    vehicles,
    page,
    pageSize,
    totalNumber,
  }) => ({
    ...state, vehicles,
    page,
    pageSize,
    totalNumber,
  })),
  on(Actions.setMaintenancesLoading, (state, { isLoading }) => ({
    ...state,
    maintenances: {
      ...state.maintenances,
      isLoading,
    }
  })),
  on(Actions.setMaintenancesFilters, (state, { filters }) => ({
    ...state,
    maintenances: {
      ...state.maintenances,
      filters: {
        ...state.maintenances.filters,
        ...filters,
      },
    }
  })),
  on(Actions.setMaintenancesPaginator, (state, { paginator }) => ({
    ...state,
    maintenances: {
      ...state.maintenances,
      paginator,
    }
  })),
  on(Actions.setMaintenancesList, (state, { response }) => ({
    ...state,
    maintenances: {
      ...state.maintenances,
      data: response.maintenances,
      totalCount: response.total,
    }
  })),
);


